export const VISIT_TYPE_CONFIG = {
  visiteur_simple: {
    label: 'Espace ouvert (accès libre)',
    fields: [],
    ndaRequired: false,
  },
  evenement: {
    label: 'Événement',
    fields: ['eventId'],
    ndaRequired: false, // overridden per-event by staff toggle
  },
  invite_company: {
    label: 'Invité (entreprise)',
    fields: ['hostCompany', 'hostContactName'],
    ndaRequired: true,
  },
  invite_person: {
    label: 'Invité (personne)',
    fields: ['hostPersonName'],
    ndaRequired: true,
  },
  fournisseur: {
    label: 'Fournisseur / Livraison',
    fields: ['supplierCompany', 'svContact'],
    ndaRequired: false,
  },
  reunion: {
    label: 'Entretien / Réunion',
    fields: ['hostCompany', 'hostContactName'],
    ndaRequired: true,
  },
  commercial: {
    label: 'Visite commerciale',
    fields: ['targetCompany', 'visitPurpose'],
    ndaRequired: true,
  },
};
